<template>
  <div class="min-vh-100">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">SETTING TIME</h1>
      <button class="create-button" @click="onOpenModal">
        <div>
          <font-awesome-icon icon="plus-square" />
          <span class="ml-2"> CREATE</span>
        </div>
      </button>
      <ModalCreateOrEditTime
        ref="createEditTimeModal"
        :form="form"
        :dateLists="dateLists"
        :onSubmit="onSubmit"
        :v="$v"
      />
    </div>
    <div class="mt-3 bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="details"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(startTime)="data">
          <span>{{ `${data.item.startTime.substring(0, 5)}น.` }}</span>
        </template>
        <template v-slot:cell(endTime)="data">
          <span>{{ `${data.item.endTime.substring(0, 5)}น.` }}</span>
        </template>
        <template v-slot:cell(active)="data">
          <span v-if="data.item.active" class="text-success">เปิดใช้งาน</span>
          <span v-else class="text-danger">ปิดใช้งาน</span>
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-around">
            <b-link class="text-link" @click="onEdit(data.item)">แก้ไข</b-link>
            <b-link class="text-link" @click="onDeleteModal(data.item)"
              >ลบ</b-link
            >
          </div>
        </template>
      </b-table>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalCreateOrEditTime from "./component/ModalCreateOrEditTime.vue";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
export default {
  name: "SettingTime",
  components: {
    ModalAlert,
    ModalAlertConfirm,
    ModalAlertError,
    ModalCreateOrEditTime,
  },
  data: function() {
    return {
      modalMessage: "",
      requestIdDelete: null,
      form: {
        name: "",
        id: 0,
        dayId: 1,
        startTime: "",
        endTime: "",
        active: "",
      },
      isBusy: false,
      dateLists: [],
      fields: [
        {
          key: "name",
          label: "วันทำการ",
          class: "w-100px",
          thStyle: {
            background: "white",
          },
        },
        {
          key: "startTime",
          label: "เวลาเปิดทำการ",
          class: "w-100px",
          thStyle: {
            background: "white",
          },
        },
        {
          key: "endTime",
          label: "เวลาปิดทำการ",
          class: "w-100px",
          thStyle: {
            background: "white",
          },
        },
        {
          key: "active",
          label: "สถานะ",
          class: "w-100px",
          thStyle: {
            background: "white",
          },
        },
        {
          key: "id",
          label: "id",
          class: "w-100px",
          thStyle: {
            background: "white",
            color: "white",
          },
        },
      ],
      details: [],
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      dayId: {
        required,
      },
      startTime: {
        required,
      },
      endTime: {
        required,
      },
      active: {
        required,
      },
    },
  },
  created: async function() {
    await this.getSettingTime();
    await this.getDateList();
  },
  methods: {
    getSettingTime: async function() {
      this.isBusy = true;
      const url = `${this.$baseUrl}/BusinessHour`;
      await this.axios.get(url).then((data) => {
        if (data.result === 1) {
          this.details = data.detail;
          this.isBusy = false;
        }
      });
    },
    getDateList: async function() {
      this.isBusy = true;
      const url = `${this.$baseUrl}/BusinessHour/day`;
      await this.axios.get(url).then((data) => {
        if (data.result === 1) {
          this.dateLists = data.detail;
          this.isBusy = false;
        }
      });
    },
    onOpenModal() {
      this.setForm({})
      this.$v.$reset()
      this.$refs.createEditTimeModal.showModal = true;
    },
    onEdit(data) {
      this.setForm(data)
      this.$v.$reset();
      this.$refs.createEditTimeModal.showModal = true;
    },
    onDeleteModal(data) {
      this.requestIdDelete = data.id;
      this.modalMessage = `คุณต้องการลบ ${data.name} เวลา ${data.startTime} - ${data.endTime} ใช่หรือไม่?`;
      this.$refs.ModalAlertConfirm.show();
    },
    setForm(data){
        this.form = {
        name: data && data.name ? data.name : "" ,
        id: data && data.id ? data.id : 0,
        brandId: 1,
        dayId: data && data.dayId ? data.dayId : null,
        startTime: data && data.startTime ? data.startTime : "",
        endTime: data && data.endTime ? data.endTime : "",
        active: data && data.active ? data.active : true,
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      this.form.startTime = moment(this.form.startTime).format("HH:mm:ss");
      this.form.endTime = moment(this.form.endTime).format("HH:mm:ss");
      const saveUrl = `${this.$baseUrl}/BusinessHour/`;
      await this.axios
        .post(saveUrl, this.form)
        .then((data) => {
          this.modalMessage = data.message;
          if (data.result == 1) {
            this.$refs.createEditTimeModal.showModal = false;
            this.$refs.modalAlert.show();
          } else {
            this.$refs.createEditTimeModal.showModal = false;
            this.$refs.modalAlertError.show();
          }
        })
        .catch((error) => {
          this.modalMessage = error;
          this.$refs.createEditTimeModal.showModal = false;
          this.$refs.modalAlertError.show();
        });
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      const id = this.requestIdDelete;
      const deleteUrl = `${this.$baseUrl}/BusinessHour/${id}`;
      await this.axios.delete(deleteUrl).then((data) => {
        this.modalMessage = data.message;
        if (data.result == 1) {
          this.$refs.modalAlert.show();
        } else {
          this.$refs.modalAlertError.show();
        }
      });
    },
    async hadleModalAlertClose() {
      this.$refs.modalAlert.hide();
      await this.getSettingTime();
    },
  },
};
</script>

<style lang="scss" scoped>
.create-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #5b57a5;
  color: #ffffff !important;
  border-radius: 4px;
  border: none;
}

.text-link {
  text-decoration: underline;
  color: #0062ff;
}
</style>
